/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**window.addEventListener("load", (event) => {
  document.getElementsByClassName("shopify-payment-button__button")[0].disabled = true;
});*/

/*window.addEventListener('DOMContentLoaded', function() {
  document.getElementsById("main-product-checkout").classList.add("disableDiv");
}, true);*/

function handleClick(cb, element) {
  if(cb.checked){
    document.getElementById(element).disabled = false;
  } 
  if(!cb.checked) {
    document.getElementById(element).disabled = true;
  }
}

function handleClickByClassName(cb, element) {
  if(cb.checked){
    document.getElementsByClassName(element)[0].disabled = false;
  } 
  if(!cb.checked) {
    document.getElementsByClassName(element)[0].disabled = true;
  }
}

function handleDivClickByClassName(cb, element) {
  if(cb.checked){
    document.getElementsByClassName(element)[0].classList.remove("disableDiv");
  } 
  if(!cb.checked) {
    document.getElementsByClassName(element)[0].classList.add("disableDiv");
  }
}

function handleDivClick(cb, element) {
 if(cb.checked){
     document.getElementById(element).classList.remove("disableDiv");
  } 
  if(!cb.checked) {
     document.getElementById(element).classList.add("disableDiv");
}
}
/**window.addEventListener("load", (event) => {
  document.getElementById("main-cart-checkout").disabled = true;
});*/